import React from 'react';
import { formatDuration } from '../../src/js/lib/duration';
import moment from 'moment/moment';

/**
 * EffortTooltip - Displays detailed information about a contest segment effort
 *
 * @param {Object} props
 * @param {Object} props.effort - The effort data
 * @param {string} props.userName - The user's name
 */
const EffortTooltip = ({ effort, userName }) => {
  return (
    <div>
      <div className='flex justify-between mb-4'>
        <span className='pr-8 font-medium small-body-text'>{userName}</span>
        <span className='mini-text'>{effort.points}pts</span>
      </div>

      <div className='grid grid-cols-2 gap-x-6 gap-y-1 mini-text text-left'>
        <span>
          <span className='font-medium'>Time:</span>{' '}
          {formatDuration(effort.duration)}
        </span>

        {effort.avg_power_watts ? (
          <span>
            <span className='font-medium'>Watt:</span>{' '}
            {effort.avg_power_watts.toFixed(0)}
          </span>
        ) : null}

        {effort.speed && (
          <span>
            <span className='font-medium'>Speed:</span> {effort.speed} km/h
          </span>
        )}

        {effort.pace && (
          <span>
            <span className='font-medium'>Pace:</span>{' '}
            {formatDuration(effort.pace)} /km
          </span>
        )}

        {effort.power_watt_per_kg != null && (
          <span>
            <span className='font-medium'>W/kg:</span>{' '}
            {effort.power_watt_per_kg.toFixed(1)}
          </span>
        )}

        {effort.completed_at && (
          <span className='col-span-2'>
            {moment(effort.completed_at).format('MMM DD, YYYY')}
          </span>
        )}
      </div>

      <div className='w-full mt-4 text-right'>
        <button
          className='report-button mini-text underline'
          data-reportable-type='SegmentEffort'
          data-reportable-id={effort.segment_effort_id}
        >
          Report
        </button>
      </div>
    </div>
  );
};

export default EffortTooltip;
